import styles from './PlayerTypePill.module.css';

export default function PlayerTypePill({ isMember }) {
  return (
    <span className={isMember ? styles.member : styles.guest}>
      {isMember ? 'Member' : 'Guest'}
    </span>
  );
}
